import { Icon, Text, HStack, Stack, VStack } from '@genial/components';
import { Pressable } from 'native-base';
import React from 'react';

import { TableContent } from '../../../../../../../../../components/TableContent';
import { useGlobalAssetContext } from '../../../../../contexts';
import { useClubsAssetContext } from '../../../../../contexts/products/Clubs';
import { LateralBar } from '../../../components/LateralBar';
import { clubsTableHead } from '../constants';
import { ListLoadingItemMobile } from '../ListLoadingItem/mobile';

import { ClubsItemTypes } from '.';

export const ClubsItemMobile: React.FC<ClubsItemTypes.Props> = ({ offer }) => {
  const { setModalOpen, setOfferSelected } = useClubsAssetContext();
  const { infoGetter, selectedTab, accountId } = useGlobalAssetContext();

  const { Button, isSelected, forceLoading } = infoGetter('clubs', offer, 'clubId');

  const onOpenDetailsModal = () => {
    setModalOpen(true);
    setOfferSelected({ ...offer, accountId: accountId || 0 });
  };

  const middleInfos1 = [
    {
      label: clubsTableHead[1].title,
      value: <Text color="neutral.dark">{offer.managerNameNormalized}</Text>,
      w: '100%',
    },
  ];

  const middleInfos2 = [
    {
      label: clubsTableHead[4].title,
      value: <Text color="neutral.dark">{offer.cutoffTimeNormalized}</Text>,
      w: '33%',
    },
    {
      label: clubsTableHead[3].title,
      value: <Text color="neutral.dark">{offer.minimumApplicationNormalized}</Text>,
      w: '33%',
    },
    {
      label: '',
      value: (
        <Stack alignSelf="flex-end">
          <Button
            id={selectedTab.typeGetterId}
            offer={offer}
            productContextConstant={selectedTab}
          />
        </Stack>
      ),
      w: '33%',
    },
  ];

  const infos = [middleInfos1, middleInfos2];

  if (forceLoading) {
    return <ListLoadingItemMobile />;
  }

  return (
    <TableContent direction="row" space={0} p={0} px="inline.xxxs" isHighlighted={isSelected}>
      <LateralBar
        backgroundColor={selectedTab.color}
        borderTopLeftRadius="sm"
        borderBottomLeftRadius="sm"
      />
      <VStack padding="inset.sm" space="stack.xxxs" w="full">
        <HStack alignItems="center" space="inline.quarck">
          <Pressable onPress={onOpenDetailsModal}>
            <Icon name="Info" size="xs" />
          </Pressable>
          <Text variant="semibold" color="neutral.black" fontSize="lg">
            {offer.clubNameNormalized}
          </Text>
        </HStack>
        {infos.map((info, i) => (
          <HStack justifyContent="space-between" key={`infos-${i}`}>
            {info.map(({ label, value, w }) => (
              <VStack w={w} space="stack.quarck" key={label}>
                {!!label && (
                  <Text color="neutral.black" variant="semibold">
                    {label}
                  </Text>
                )}
                {value}
              </VStack>
            ))}
          </HStack>
        ))}
      </VStack>
    </TableContent>
  );
};
